import { render } from "./BenefitsCard.vue?vue&type=template&id=5b5b81d3"
import script from "./BenefitsCard.vue?vue&type=script&lang=js"
export * from "./BenefitsCard.vue?vue&type=script&lang=js"

import "./BenefitsCard.vue?vue&type=style&index=0&id=5b5b81d3&lang=css"
script.render = render

export default script